export default {
  message: {
    hello: "你好",
    welcome: "欢迎使用我们的应用",
    cn: "简体中文",
    fcn: "繁體中文",
    en: "English",
    home: "首页",
    employeeList: "员工列表",
    restaurantList: "餐厅列表",
    lloginName: "登录名",
    password: "密码",
    loginin: "登录",
    inplloginName: "请输入邮箱",
    inpPassword: "请输入密码",
    RestaurantName: "餐厅名称",
    Contactinformation: "联系方式",
    region: "地区",
    address: "地址",
    workersEmployed: "用工人数",
    Blacklist: "黑名单",
    Employmenttime: "打卡时间",
    QRcode: "二维码",
    group: "集团",
    Businesshours: "营业时间",
    Businessstatus: "营业状态",
    Travelmethod: "行程方式",
    operation: "操作",
    edit: "编辑",
    delete: "删除",
    Add: "新增",
    taurantname: "请输入餐厅名",
    Pleaseselectaregion: "请选择地区",
    Successfullyadded: "添加成功",
    Successfullydeleted: "删除成功",
    Deletefailed: "删除失败",
    deletethecurrententry: "删除当前项",
    delete: "删除",
    confirm: "确定",
    prompt: "提示",
    Permanentlydelete: "此操作将永久删除该数据, 是否继续?",
    Successfullymodified: "修改成功",
    changeStatus: "此操作将切换员工不确定状态, 是否继续",
    canceled: "已取消",
    changeFailed: "切换状态失败",
    changeSuccess: "切换状态成功",
    Export: "导出",
    Name: "姓名",
    Gender: "性别",
    Phone: "手机号",
    Paymentmethod: "收款方式",
    Selfie: "自拍",
    IDcard: "身份证",
    Unqualifiedemployees: "不合员工",
    Remarks: "备注",
    Employeeidentity: "员工身份",
    Mattersattention: "注意事项",
    Fixedposition: "固定位置",
    LastWork: "最后工作餐厅位置",
    LongtermWorker: "长工",
    ShorttermWorker: "短工",
    TemporaryWorkers: "临时工",
    SubstituteWorker: "替工",
    Transfer: "转账",
    cash: "现金",
    check: "支票",
    userList: "用户列表",
    userName: "用户名",
    avatar: "头像",
    account: "账号",
    password: "密码",
    role: "角色",
    creatTime: "创建时间",
    lastLoginTime: "最后登录时间",
    mailbox: "邮箱",
    lastLoginIp: "最后登录ip",
    accountStatus: "账号状态",
    roleList: "角色列表",
    menuList: "菜单列表",
    pleaseEnter: "请输入",
    jiazaishi: "加载失败",
    EmployeeInformation: "员工管理",
    RestaurantInformation: "餐厅管理",
    usermanagement: "用户管理",
    name: "名称",
    description: "简介",
    index: "序号",
    rolename: "角色名",
    kejian: "可见",
    bukejian: "不可见",
    noclick: "取消",
    seatchmap: "搜索goole地图",
    dakaf: "打卡范围",
    loginout: "退出登录",
    PersonalCenter: "个人中心",
    groupList: "集团列表",
    chineseName: "中文名",
    englishName: "英文名",
    contacts: "联系人",
    contactNumber: "联系电话",
    settlementMethod: "结算方式",
    spaymentStatus: "本月收款情况",
    receivingAddress: "收款地址",
    starttime: "开始时间",
    endtime: "结束时间",
    groupAddress: "集团地址",
    invoice: "发票",
    correctFormat: "正确格式的",
    print: "打印",
    employeeStatus: "状态",
    auditStatus: "审核状态",
    setchuser: "搜索用户",
    managerNumber: "经理手机号",
    enable: "启用",
    disabled: "禁用",
    setground: "搜索集团",
    addclock: "添加打卡时间",
    clockname: "打卡名称",
    placeholderclockname: "请输入内容 列如：早班",
    auditEmployeelist: "审核列表",
    sex: "性别",
    topjingli: "上级经理",
    auditStatus0: "未审核",
    auditStatus1: "审核通过",
    auditStatus2: "审核不通过",
    refuserReason: "拒绝原因",
    Audit: "审核",
    contactPerson: "联系人",
    updatasuc: "更新成功",
    updatasucphoneid: "此操作将重置手机id",
    coledit: "颜色编辑",
    notices: "消息管理",
    noticesList: "通知列表",
    name_tc: "名称",
    contact_phone: "联系方式",
    business_status: "营业状态",
    restaurantgroup_id: "集团名称",
    districts_id: "地区",
    navigation_description: "行程方式",
    address_tc: "地址",
    contact_person: "联系人",
    noticeTitle: "通知标题",
    noticeContent: "通知内容",
    noticeType: "通知类型",
    employeeIds: "指定员工",
    employeeType: "员工类型",
    groupName: "分组名称",
    employeeNum: "指定员工人数",
    backlist1: "黑名单",
    color: "颜色",
    leaveMessage: "留言类型",
    messageRecord: "留言记录",
    is_emergency: "是否紧急",
    created_at: "创建时间",
    updated_at: "更新时间",
    goodli: "好碗力",
    details: "详情",
    yes: "是",
    no: "否",
    weigh: "权重",
    name_en: "名称（英文）",
    type_name_tc: "留言类型",
    msgContent: "留言内容",
    created_start: "留言开始时间",
    created_end: "留言结束时间",
    handle_end: "处理时间",
    msgName: "留言人",
    msgObject: "留言对象",
    schedulingManagement: "排班管理",
    scheduling: "排班信息",
    mark: "餐厅简称",
    placeSelect: "请选择",
    nullData: "暂无数据",
    Monday: "周一",
    employenamee: "员工姓名",
    adddname: "添加",
    placRautse: "请先选择餐厅",
    placYuangong: "请选择员工",
    dateType1: "常规排班",
    dateType2: "节假日",
    dateType3: "特殊排班",
    dateType4: "排班类型",
    startDdate: "用工开始时间",
    endDdate: "用工结束时间",
    isRest1: "不休息",
    isRest2: "休息",
    isRest3: "是否休息",
    clockStart1: "打卡开始时间",
    clockEnd1: "打卡结束时间",
    taglds: "班次",
    weeks1: "周一",
    weeks2: "周二",
    weeks3: "周三",
    weeks4: "周四",
    weeks5: "周五",
    weeks6: "周六",
    weeks0: "周日",
    weeks8: "用工周期",
    minusHours: "减少工时",
    weigh1: "优先级",
    weigh3: "数字越大优先级越高",
    addbanci: "请选择班次",
    addyonggo: "请选择用工周期",
    workTag: "打卡班次",
    workTagname: "班次名称",
    descs: "描述",
    isedit1: "是否修改",
    districts: "地区列表",
    districtName: "地区名称",
    sex1: "男",
    sex2: "女",
    yes1: "正确",
    operationsuc: "操作成功",
    maps_address: "谷歌地址",
    workClockIn: "打卡记录",
    employee: "员工姓名",
    onwork_at: "上班打卡时间",
    offwork_at: "下班打卡时间",
    status: "状态",
    dateselection: "日期选择",
    supervisor: "所属主管",
    updatePhone: "更新手机",
    refresh: "刷新",
    versionManage: "版本管理",
    read: "已读",
    start_date: "生效开始日期",
    end_date: "生效结束日期",
    noRead: "未读",
    photoRec: "拍照记录",
    tiemchanchan: "时间选择",
    age: "年龄",
    photo: "照片",
    isOnWork: "是否在职",
    liveDistricts: "居住地区",
    restaurant: "排班餐厅",
    restaurantGroup: "排班集团",
    handle_at: "处理时间",
    content: "留言内容",
    customer: "客服排班",
    weekday: "工作日",
    weeks7: "周日",
    weeks11: "休息周期",
    worktimme3: "用工时间",
    districtsss: "排班地区",
    scheduleTime: "可调度时间",
    date: "日期",
    settlement_method: "收款方式",
    remark: "备注",
    live_districts_id: "居住地区",
    hourly_wage: "时薪",
    service_level: "能力等级",
    work_hardness: "工作难度等级",
    arrange_hardness: "安排难度等级",
    navigation_tc: "行程方式",
    phone: "电话",
    name_tc_short: "餐厅简称",
    clientuser: "客户端列表",
    referrer: "推荐人列表",
    synchronous: "同步排班",
    attitude_level: "态度等级",
    workuse:'任务导出',
    merchant:'商户管理',
    contactPhone: '联系电话',
    search: '搜索'
  }
};



// WEBPACK FOOTER //
// ./src/locales/cn.js